module.exports = __webpack_public_path__ + "static/media/close.d33782a0.svg";